import React, { useState, useEffect } from 'react'; // Added useState and useEffect
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase'; // Added db
import { signOut } from 'firebase/auth';
import { doc, getDoc, getDocs, collection } from 'firebase/firestore'; // Added Firestore functions


const AdminDashboard = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  

  const [stats, setStats] = useState({
    students: 0,
    teachers: 0,
    lessons: 0
  });

useEffect(() => {
    const fetchAdminData = async () => {
      try {
        // 1. Get User Data for Welcome Message
        const user = auth.currentUser;
        if (user) {
          const userSnap = await getDoc(doc(db, 'users', user.uid));
          if (userSnap.exists()) setUserName(userSnap.data().name || 'Admin');
        }

        // 2. Calculate Stats from Firestore
        const usersSnap = await getDocs(collection(db, 'users'));
        let studentCount = 0;
        let teacherCount = 0;

        usersSnap.forEach((doc) => {
          const data = doc.data();
          // Using lowercase to match your database
          if (data.role === 'student') studentCount++;
          if (data.role === 'teacher') teacherCount++;
        });

        // 3. Get Lessons Count
        // If you don't have a 'lessons' collection yet, this will just be 0
        const lessonsSnap = await getDocs(collection(db, 'lessons'));
        
        setStats({
          students: studentCount,
          teachers: teacherCount,
          lessons: lessonsSnap.size || 0 
        });

      } catch (error) {
        console.error("Error fetching admin stats:", error);
      }
    };

    fetchAdminData();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/signin');
    } catch (error) {
      console.error('❌ Sign out error:', error);
    }
  };

  return (
    <div style={styles.container}>
      {/* 1. TOP HEADER */}
      <header style={styles.header}>
        <div>
          <h1 style={styles.title}>
  <span role="img" aria-label="shield">🛡️</span> Admin Console
</h1>
          <p style={styles.subtitle}>Welcome back, {userName || 'Admin'}</p>
        </div>
        <button onClick={handleSignOut} style={styles.signOutButton}>
          Sign Out
        </button>
      </header>

      {/* 2. QUICK STATS */}
      <div style={styles.statsGrid}>
        <div style={styles.statCard}>
          <span style={styles.statLabel}>Total Students</span>
          <span style={styles.statNumber}>{stats.students}</span>
        </div>
        <div style={styles.statCard}>
          <span style={styles.statLabel}>Active Teachers</span>
          <span style={styles.statNumber}>{stats.teachers}</span>
        </div>
        <div style={styles.statCard}>
          <span style={styles.statLabel}>Lessons Live</span>
          <span style={styles.statNumber}>{stats.lessons}</span>
        </div>
      </div>

      {/* 3. NAVIGATION MENU GRID */}
      <div style={styles.menuGrid}>
        <button onClick={() => navigate('/admin/users')} style={styles.menuCard}>
          <div style={styles.iconCircle}><span role="img" aria-label="users">👥</span></div>
          <div style={styles.cardInfo}>
            <h3 style={styles.cardTitle}>Manage Users</h3>
            <p style={styles.cardDesc}>Assign students to teachers and manage roles.</p>
          </div>
        </button>

        <button onClick={() => navigate('/admin/analytics')} style={styles.menuCard}>
          <div style={styles.iconCircle}><span role="img" aria-label="chart">📊</span></div>
          <div style={styles.cardInfo}>
            <h3 style={styles.cardTitle}>Platform Analytics</h3>
            <p style={styles.cardDesc}>View global progress and completion rates.</p>
          </div>
        </button>

        <button style={styles.disabledCard} disabled>
          <div style={{...styles.iconCircle, background: '#e2e8f0'}}><span role="img" aria-label="books">📚</span></div>
          <div style={styles.cardInfo}>
            <h3 style={styles.cardTitle}>Course Editor</h3>
            <p style={styles.cardDesc}>Coming Soon: Edit lesson JSONs directly.</p>
          </div>
        </button>

        <button style={styles.disabledCard} disabled>
          <div style={{...styles.iconCircle, background: '#e2e8f0'}}><span role="img" aria-label="gear">⚙️</span></div>
          <div style={styles.cardInfo}>
            <h3 style={styles.cardTitle}>System Settings</h3>
            <p style={styles.cardDesc}>Coming Soon: Global app configurations.</p>
          </div>
        </button>
      </div>
    </div>
  );
};

// ... keep your existing const styles = { ... } below ...

export default AdminDashboard;

const styles = {
  container: {
    padding: '40px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#f8fafc',
    minHeight: '100vh',
    fontFamily: "'Inter', sans-serif",
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '40px',
    borderBottom: '2px solid #e2e8f0',
    paddingBottom: '20px'
  },
  title: {
    fontSize: '2.2rem',
    color: '#1e3a8a',
    margin: 0,
    fontFamily: "'Merriweather', serif",
  },
  subtitle: {
    color: '#64748b',
    margin: '5px 0 0 0'
  },
  signOutButton: {
    padding: '10px 24px',
    backgroundColor: '#ef4444',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '40px'
  },
  statCard: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    border: '1px solid #e2e8f0',
    display: 'flex',
    flexDirection: 'column'
  },
  statLabel: { color: '#64748b', fontSize: '0.85rem', fontWeight: 'bold', textTransform: 'uppercase' },
  statNumber: { fontSize: '1.8rem', fontWeight: '800', color: '#1e3a8a' },
  menuGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '25px',
  },
  menuCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '25px',
    backgroundColor: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: '15px',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
    ":hover": { transform: 'translateY(-2px)', boxShadow: '0 10px 15px rgba(0,0,0,0.05)' }
  },
  disabledCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '25px',
    backgroundColor: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: '15px',
    textAlign: 'left',
    opacity: 0.7,
    cursor: 'not-allowed'
  },
  iconCircle: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: '#eff6ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    flexShrink: 0
  },
  cardTitle: { margin: 0, fontSize: '1.2rem', color: '#1e3a8a' },
  cardDesc: { margin: '5px 0 0 0', fontSize: '0.9rem', color: '#64748b' }
};